import { render, staticRenderFns } from "./MoneyBonuses.vue?vue&type=template&id=4948a27d&"
import script from "./MoneyBonuses.vue?vue&type=script&lang=js&"
export * from "./MoneyBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports